const viewOrgListingTypes = ['JOB', 'INTERNSHIP', 'VOLOP', 'EVENT'] as const;

export type ViewOrgPageListingTab = (typeof viewOrgListingTypes)[number];

export function isViewOrgPageListingTab(
  value: string | undefined,
): value is ViewOrgPageListingTab {
  return Boolean(value && viewOrgListingTypes.includes(value));
}
